import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.boltin.com';
const CUSTOMERS_API_PATH = '/api/customers';

const getCustomers = async (searchTerm = '') => {
  const response = await axios.get(`${API_BASE_URL}${CUSTOMERS_API_PATH}?search=${searchTerm}`);
  return response.data.data;
};

// --- THE FIX IS HERE ---
// This is now the ONLY function needed to get all data for the 360° view.
const getCustomerDetails = async (id) => {
  const response = await axios.get(`${API_BASE_URL}${CUSTOMERS_API_PATH}/${id}/details`);
  return response.data.data;
};

const createCustomer = async (customerData) => {
  const response = await axios.post(`${API_BASE_URL}${CUSTOMERS_API_PATH}`, customerData);
  return response.data.data;
};

const updateCustomer = async (id, customerData) => {
  const response = await axios.put(`${API_BASE_URL}${CUSTOMERS_API_PATH}/${id}`, customerData);
  return response.data.data;
};

const deleteCustomer = async (id) => {
  await axios.delete(`${API_BASE_URL}${CUSTOMERS_API_PATH}/${id}`);
  return id;
};

// The getCustomerById and getCustomerSalesHistory functions are no longer needed.

const customerService = {
  getCustomers,
  getCustomerDetails, // <-- The new, powerful function
  createCustomer,
  updateCustomer,
  deleteCustomer,
};

export default customerService;